module.exports = __webpack_public_path__ + "img/delete.a61067bb.svg";